import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['container', 'block']

  add(event) {
    event.preventDefault();
    const lastBlock = this.blockTargets[this.blockTargets.length - 1]
    if (!lastBlock) return

    const newBlock = lastBlock.cloneNode(true)
    newBlock.querySelectorAll('input').forEach(input => { input.value = "" })

    this.containerTarget.appendChild(newBlock)
  }

  remove(event) {
    event.preventDefault();
    const block = event.currentTarget.closest("[data-dynamic-fields-target='block']")

    if (this.blockTargets.length > 1) {
      block.remove()
    } else {
      newBlock.querySelectorAll('input').forEach(input => { input.value = "" })
    }
  }
}